export const convertToMaybeBase64 = (value: string) => {
  return value.substring(value.indexOf(",") + 1);
};
